import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { AdminLocationAlert } from "../../../components/AdminLocationAlertsComponents/AdminLocationAlertCreateModal/Form/schema";
import { AdminLocationAlertsQueryParams } from "../../../components/AdminLocationAlertsComponents/AdminLocationAlertsList/types";
import DataSvc from "../../../services/dataSvc";

const useAdminLocationAlerts = (
  queryParams?: AdminLocationAlertsQueryParams
) => {
  const queryClient = useQueryClient();

  const query = useQuery({
    queryKey: ["adminLocationAlerts", queryParams],
    queryFn: () => DataSvc.getAdminLocationAlerts(queryParams),
    enabled: !!queryParams
  });

  const createMutation = useMutation({
    mutationFn: (data: AdminLocationAlert) =>
      DataSvc.createAdminLocationAlert(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["adminLocationAlerts"] });
    }
  });

  const create = async (data: AdminLocationAlert) => {
    await createMutation.mutateAsync(data);
  };

  const removeMutation = useMutation({
    mutationFn: (id: string) => DataSvc.deleteAdminLocationAlert(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["adminLocationAlerts"] });
    }
  });

  const remove = (id: string) => {
    removeMutation.mutate(id);
  };

  const updateMutation = useMutation({
    mutationFn: (data: AdminLocationAlert) =>
      DataSvc.updateAdminLocationAlert(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["adminLocationAlerts"] });
    }
  });

  const update = async (data: AdminLocationAlert) => {
    await updateMutation.mutateAsync(data);
  };

  return { ...query, create, remove, update };
};

export default useAdminLocationAlerts;
